import { Button, Tooltip } from 'src/design-system'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import cn from 'classnames'
import { CreateFormModalButton } from 'components/create-form-modal'
import { StartCheckinButtonVm } from './start-checkin-button-vm'
import { store } from 'store/index'
import { User } from 'store/modules/users'
import { useStore } from 'store/context'

export type StartCheckinButton = {
  className?: string
  source: string
  user: User
  variant?: React.ComponentProps<typeof Button>['variant']
}

export const StartCheckinButton: React.FunctionComponent<StartCheckinButton> = observer((props) => {
  const { className, source, user, variant = 'default' } = props

  const { currentUser } = useStore()

  const vm = React.useMemo(() => {
    return new StartCheckinButtonVm()
  }, [])

  if (!currentUser) return null

  if (user.isCurrentUser) {
    return (
      <CreateFormModalButton
        label="Start Check-in"
        source={source}
        tabs={['checkin']}
        user={currentUser}
        variant={variant}
      />
    )
  }

  const tooltipContent = vm.tooltipContent(user)

  if (tooltipContent) {
    return (
      <Tooltip content={tooltipContent}>
        <Button
          className={cn('bg-theme-40 opacity-50 text-white', className)}
          disabled
          variant={variant}
        >
          Start Check-in
        </Button>
      </Tooltip>
    )
  }

  // When the org has joint review configured and the IC's team has it enabled,
  // the manager opens the same checkin form modal (with toggle or required banner)
  // instead of firing the API directly. The IC user is passed so the form pre-fills
  // the IC's position and assessor fields correctly.
  if (vm.isJointReviewApplicable(user)) {
    return (
      <CreateFormModalButton
        label="Start Check-in"
        source={source}
        tabs={['checkin']}
        user={user}
        className={className}
        variant={variant}
      />
    )
  }

  return (
    <Button
      className={className}
      disabled={store.checkins.loading}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault()
        vm.onClick(user.id, currentUser.id, source)
      }}
      variant={variant}
    >
      Start Check-in
    </Button>
  )
})
